export default class Enum {
    constructor(axios) {
        this.axios = axios;
    }

    async cache() {
        return await this.axios.$get("cache.json");
    }
}
